import React from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import One from './OnePopUpComment';
import { arrDiff } from '../../utils/util';
const MAX_ROW = 3;
@inject('rootStore')
@observer
class PopUpCommentWrapper extends React.Component {
  @observable allComments = [];
  @observable showingComments = []; //当前正在展示的评论 最多3条
  @observable shownComments = []; //已经显示完成的评论
  getPopUpCommentList = () => {
    this.allComments = [
      ...arrDiff(
        [
          ...this.props.rootStore.commentStore.topCommentList.slice(),
          ...this.props.rootStore.commentStore.commentList
        ],
        this.shownComments,
        function(arr1, arr2) {
          return arr1.id === arr2.id;
        }
      )
    ];
    // console.log(this.allComments.length, 'get list')
  };

  @action check = () => {
    const allLength = this.allComments.length;
    // const {commentStore}  =  this.props.rootStore;
    // 因为根据代码，allComments里边置顶的评论不能被删除，大于的时候再做这个处理，否则会出现重复数据
    if (allLength) {
      //console.log('in', allLength, commentStore.topCommentList.length);
      const comment = this.allComments.shift();
      this.shownComments = [...this.shownComments, comment];
      if (this.showingComments.length < MAX_ROW) {
        this.showingComments.push(comment);
      } else {
        this.showingComments = [
          ...this.showingComments.slice(1, MAX_ROW),
          comment
        ];
        //this.showingComments.splice(this.showingComments-1,1,comment);
      }
    }
  };
  componentDidMount() {
    this.getPopUpCommentList();
    this.getListTimer = setInterval(this.getPopUpCommentList, 10000);
    this.check();
    this.timer = setInterval(this.check, 3000);
  }
  componentWillUnmount() {
    clearInterval(this.getListTimer);
    clearInterval(this.timer);
  }
  render() {
    const { type } = this.props;
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column-reverse',
          pointerEvents: 'none'
        }}
        className="ignore-move pop-up-wrapper"
      >
        {this.showingComments.map(comment => (
          <One
            type={type}
            key={comment.id}
            content={comment.content}
            master={comment.master}
            photo={comment.photo}
            name={comment.nickname}
          />
        ))}
      </div>
    );
  }
}

export default PopUpCommentWrapper;
